<template>
  <div class="phonePage04" :style="bg">
    <div class="pt_area">
      <div class="pt_title">{{ title }}</div>
      <!-- <div class="pt_line"></div>
      <div class="pt_label">PROFESSIONAL</div> -->
    </div>
    <div class="pm_area">
      <div class="pm_img">
        <img :src="$tools.localStorageFn.get('PAGE_DATE').banner3_logo" alt="" />
      </div>
      <div class="pm_inputArea">
        <!-- <input type="text" placeholder="按姓氏首字母搜索" /> -->
        <input type="text" placeholder="按律师姓名搜索" v-model="name" />
        <el-select v-model="field" placeholder="按业务领域搜索" ref="phontSelect">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="pb_area">
      <div class="pb_tbtn" @click="
        $router.push(
          '/mobileProfessionalPersonnel?name=' + name + '&field=' + field
        )
        ">
        搜索
      </div>
      <div class="pb_bbtn" @click="$router.push('/mobileProfessionalPersonnel')">
        查看专业人员 >
      </div>
    </div>
    <floatService style="position: absolute;"></floatService>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: {
        background:
          "url(" +
          this.$tools.localStorageFn.get("PAGE_DATE").banner3 +
          ") no-repeat center center",
      },
      value: "",
      // 业务领域
      options: [],
      name: "",
      field: "",
      title: '',
    };
  },
  created() {
    this.getTitle(52)
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      this.options = this.$tools.localStorageFn.get("FIELD_LIST");
    },
    getTitle(id) {
      this.$tools.localStorageFn.get("CATEGORIES_LIST").forEach((item) => {
        if (item.id == id) {
          console.log('item', item)
          this.title = item.title;
        } else if (item.children.length > 0) {
          item.children.forEach((ele) => {
            console.log('ele', ele)
            if (ele.id == id) {
              this.title = ele.title;
            }
          })
        }
      })
    },
  },
};
</script>

<style lang="scss">
.phonePage04 {
  width: 100%;
  height: 100%;
  background-size: 100% 100% !important;
  padding: 17.23vh 2.3rem 0;
  position: relative;

  .pt_area {
    width: 100%;
    margin-bottom: 3.3rem;

    .pt_title {
      font-size: 3.2rem;
      font-family: JingZhe_XiaoWei;
      font-weight: 400;
      color: #013060;
      text-align: center;
    }

    .pt_line {
      width: 5.9rem;
      height: 0.2rem;
      background: #013060;
      margin: 0.7rem auto 0.9rem;
    }

    .pt_label {
      font-size: 1.4rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #013060;
      text-align: center;
    }
  }

  .pm_area {
    .pm_img {
      transform: translateX(6.0rem);
      opacity: 0;
      transition: 1s 0.6s;
      width: 100%;
      margin-bottom: 2.9rem;

      img {
        width: 100%;
      }
    }

    .pm_inputArea {
      transform: translateY(6.0rem);
      opacity: 0;
      transition: 1s 0.6s;

      input {
        font-size: 1.2rem;
        height: 3.4rem;
        box-sizing: border-box;
        width: 100%;
        border: 0.1rem solid #033061;
        margin-bottom: 1.3rem;
        padding: 1.1rem;
        background: transparent;
      }

      input::placeholder {
        font-size: 1.2rem;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #023060;
        line-height: 1.4rem;
      }

      .pm_select {
        box-sizing: border-box;
        width: 100%;
        border: 0.1rem solid #033061;
        padding: 1.1rem 1.7rem 1.1rem 1.1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.2rem;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #023060;
        line-height: 1.4rem;
        margin-bottom: 1.9rem;
      }

      .el-select {
        width: 100%;

        .el-input {
          border: .1rem solid #033061;

          input {
            height: 3.4rem;
            background: rgba(68, 68, 68, 0);
            margin: 0;
            // height: 52px;
            // line-height: 52px;
            border-radius: 0;
            border: none;
            padding: 1.1rem;
            font-size: 1.2rem;
            color: #033061;
          }

          input::placeholder {
            color: #033061;
            // font-size: 16px;
          }

          .el-input__suffix {
            right: 18px;

            .el-input__icon {
              font-size: 1.6rem;
              color: #093665;
              line-height: 3.4rem;
            }
          }
        }
      }
    }
  }

  .pb_area {
    margin-top: 1.9rem;
    transform: translateY(6.0rem);
    opacity: 0;
    transition: 1s 0.8s;

    .pb_tbtn {
      width: 21.2rem;
      height: 3.2rem;
      background: #013060;
      border-radius: 0.2rem;
      font-size: 1.2rem;
      font-family: SimHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 3.2rem;
      text-align: center;
      margin: 0 auto 1.4rem;
    }

    .pb_bbtn {
      width: 21.1rem;
      height: 3.4rem;
      background: rgba(1, 48, 96, 0);
      border: 0.1rem solid #033061;
      font-size: 1.2rem;
      font-family: SimHei;
      font-weight: 400;
      color: rgba(3, 48, 97, 1);
      line-height: 3.4rem;
      text-align: center;
      margin: 0 auto;
    }
  }
}

.active {
  .phonePage04 {
    .pt_title {
      animation: fade-in-top96 1.7s ease 0s 1 normal none;
    }

    .pm_img {
      transform: translate(0);
      opacity: 1;
    }

    .pm_inputArea {
      transform: translate(0);
      opacity: 1;
    }

    .pb_area {
      transform: translate(0);
      opacity: 1;
    }
  }
}
</style>